import { AxiosResponse } from 'axios';

import { api } from '../../http';

import { ApiResponse } from './interfaces';

export interface GlobalSettings {
  timesheet_split_hours_across_calendar_days: boolean;
  two_factor_authentication: boolean;
  plan_dates_department_check: boolean;
  distance_balanced_assignment: boolean;
  taskType_department_check: boolean;
  person_shift_restrictions: {
    maxMonthlyScheduledHours: number;
    maxConsecutiveDaysWithShifts: number;
  };
  department_assignment_schedule: {
    startDate: string;
    periodValue: number;
    periodType: number;
    daysLookback: number;
    scheduleSettings: Array<{
      dayNumber: number;
      weekNumber: number;
      startTime: string;
    }>;
  } | null;
}

export const GlobalSettingsService = {
  async get(): Promise<GlobalSettings> {
    const response: AxiosResponse<ApiResponse<GlobalSettings>> =
      await api.get<ApiResponse<GlobalSettings>>('globalSetting/');
    return (
      response.data?.value
    );
  },

  async update(settings: GlobalSettings): Promise<void> {
    await api.put('globalSetting/', settings);
  }
};
